import type { PosSyncMode } from '@/offline/db';

/** Pass-through — desktop wizard may choose Live Online, Local First, or Offline Always. */
export function resolveEffectivePosSyncMode(mode?: PosSyncMode | null): PosSyncMode {
  const m = mode || 'Live Online';
  if (
    m === 'Live Online' ||
    m === 'Local First Auto Sync' ||
    m === 'Offline Always Manual Sync'
  ) {
    return m;
  }
  return 'Live Online';
}
